import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat, LocalizationHelper } from '../helpers/localization.helper';
import { LocalizationService } from '../services/localization.service';

export interface DateFromToArgs {
  format?: DateFormat;
  dashSeparated?: boolean;
  toNullValue?: string;
}

function createDateFromToArgs(ls: LocalizationService, args?: DateFromToArgs): DateFromToArgs {
  return {
    dashSeparated: args?.dashSeparated ?? true,
    toNullValue: args?.toNullValue ?? ls.translate('label.infinite'),
    format: args?.format ?? 'dShort'
  };
}

@Pipe({ name: 'dateTo' })
export class DateFromToPipe implements PipeTransform {
  private locHelper = new LocalizationHelper(this.ls);

  constructor(private ls: LocalizationService) {}

  transform(from: Date | number, to: Date | number | null | undefined, args?: DateFromToArgs): string {
    const a = args ? { ...createDateFromToArgs(this.ls), ...args } : createDateFromToArgs(this.ls);
    const f = (d: Date | number) => this.locHelper.localizeDate(d, a.format!);
    return (
      `${a.dashSeparated ? '' : this.ls.translate('label.from') + ' '}${f(from)} ` +
      `${a.dashSeparated ? '-' : this.ls.translate('label.to')} ` +
      `${to ? f(to) : a.toNullValue}`
    );
  }
}
